"use client"
import * as React from "react"
import {styled} from "@mui/material/styles"
import Avatar from "@mui/material/Avatar"
import MuiDrawer, {drawerClasses} from "@mui/material/Drawer"
import Box from "@mui/material/Box"
import Divider from "@mui/material/Divider"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import Logo from "./Logo"
import MenuContent from "./MenuContent"
import OptionsMenu from "./OptionsMenu"
// import { useSession } from "next-auth/react";
// import {USER_PROFILE} from "@/app/admin/constants/common";
// import {truncateString} from "@/app/helpers/functions";

const drawerWidth = 240

const Drawer = styled(MuiDrawer)({
    width: drawerWidth,
    flexShrink: 0,
    boxSizing: "border-box",
    mt: 10,
    [`& .${drawerClasses.paper}`]: {
        width: drawerWidth,
        boxSizing: "border-box"
    }
})

export default function SideMenu() {

    // const userData = useSession()

    return (
        <Drawer
            variant="permanent"
            sx={{
                display: {xs: "none", md: "block"},
                [`& .${drawerClasses.paper}`]: {
                    backgroundColor: "background.paper"
                }
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    mt: "calc(var(--template-frame-height, 0px) + 4px)",
                    p: 1.5
                }}
            >
                <Logo/>
            </Box>
            <Divider/>
            <MenuContent/>
            <Stack
                direction="row"
                sx={{
                    p: 2,
                    gap: 1,
                    alignItems: "center",
                    borderTop: "1px solid",
                    borderColor: "divider"
                }}
            >
                <Avatar
                    sizes="small"
                    alt="Riley Carter"
                    // src={USER_PROFILE}
                    sx={{width: 36, height: 36}}
                />
                <Box sx={{mr: "auto"}}>
                    <Typography
                        variant="body2"
                        sx={{fontWeight: 500, lineHeight: "16px"}}
                    >
                        {/*{userData?.data?.user?.name}*/}
                    </Typography>
                    <Typography variant="caption" sx={{color: "text.secondary"}}>
                        {/*{truncateString(userData?.data?.user?.email || "", 16)}*/}
                    </Typography>
                </Box>
                <OptionsMenu/>
            </Stack>
        </Drawer>
    )
}
